// Texty stránky Prodejna nářadí — slovenské dvojče locale/cs/storePage.js.
// Stránka na SK není (`SHOP.pages.store` je null), modul se na SK nikdy
// nespustí (pageIs('store') === false) — dvojče žije kvůli tvaru (S3 #399).
export default {
  eshopCta: 'Prejsť do e-shopu',
  visitCta: 'Naplánovať návštevu',
  openToday: 'Dnes otvorené',
  closedToday: 'Dnes zatvorené',
  choice: 'E-shop aj osobný odber',
  choicePerex:
    'Vyberte si, ako vám to vyhovuje. Či už nakúpite online, alebo osobne, dostanete rovnaké férové ceny a poradenstvo.',
  online: 'Objednaj online',
  onlineCta: 'Do e-shopu',
  pickup: 'Vyzdvihni na predajni',
  pickupText:
    'Preferujete osobný výber? Zastavte sa u nás. Náradie si osaháte naživo, vyskúšate a spoločne vyberieme najlepšie riešenie. Osobný odber je zadarmo.',
  assort: 'Čo u nás kúpite',
  assortHint: 'Kutilom aj profesionálom',
  brands: 'Overené značky:',
  map: 'Kde nás nájdete',
  address: 'Adresa',
  hours: 'Otváracie hodiny',
  mapCta: 'Zobraziť mapu',
  mapPill: 'Otvoriť v mapách',
  video: 'Predajňa Jipos na vlastné oči',
  videoCap: 'Predajňa Jipos · Bílina',
  pickupFree: 'Osobný odber zadarmo',
  shippingLabel: 'Doprava a platba',
  heroAlt: 'Predajňa náradia Jipos v Bíline',
  galleryAlt: 'Predajňa Jipos v Bíline',
  assortment: [
    { title: 'Ručné náradie', desc: 'Kľúče, kliešte, sady bitov aj meracia technika.' },
    { title: 'Elektrické a aku náradie', desc: 'Vŕtačky, brúsky, píly a aku systémy.' },
    { title: 'Záhradná technika', desc: 'Kosačky, krovinorezy, píly a kompresory.' },
    { title: 'Príslušenstvo', desc: 'Kotúče, vrtáky, reťaze a náhradné diely.' },
  ],
};
